/* istanbul ignore next */
const styles = ({
  breakpoints,
  palette: {
    secondary: { normal }
  },
  spacing: { unit },
  typography: { fontWeightLight, fontWeightMedium }
}) => ({
  success: {},
  alertDetails: {
    display: 'flex',
    justifyContent: 'flex-start',
    fontSize: unit * 1.5,
    padding: `${unit * 1.25}px 0px`,
    '& + &': {
      borderTop: `1px solid ${normal}`
    },
    [`@media only screen and (max-width: ${breakpoints.values.sm}px)`]: {
      flexDirection: 'column'
    }
  },
  alertCol: {
    display: 'flex',
    flexGrow: 1,
    overflow: 'auto'
  },
  alertMemoCol: {
    maxWidth: unit * 40,
    wordWrap: 'break-word'
  },
  alertHead: {
    flex: 1,
    fontWeight: fontWeightMedium,
    marginBottom: unit * 0.5,
    textTransform: 'uppercase'
  },
  alertValue: {
    flex: 1,
    fontWeight: fontWeightLight
  },
  message: {
    transition: 'all  500ms',
    opacity: 1,
    transform: 'translateY(0)',
    '& .test': {
      width: '100%'
    }
  },
  messageExit: {
    transition: 'all  500ms',
    opacity: 0,
    transform: `translateY(-${unit * 3}px)`
  },
  section: {
    width: '100%'
  },
  nativeAlert: {
    padding: `${unit * 1.25}px 0px`,
    '& + &': {
      borderTop: `1px solid ${normal}`
    }
  }
});

export default styles;
